module.exports = __webpack_public_path__ + "static/media/SampleAsset.553b35f6.csv";